import { useState, useEffect } from 'react';
import { Toaster, Input, FormControl, Button, LogoutIcon, Spinner, Header, TravelportLogo, Floating, Checkbox, Form, Footer } from '@atlas-design-system/react';
import './App.css';
import Settings from './views/Settings';

function App() {
  let [credentials, setCredentials] = useState({ isSignIn: false, key: 'dawda', initData: {} });
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState();
  let [remember, setRemember] = useState(false);

  useEffect(() => {
    onSignOff();
  }, []);

  const onSignOff = () => {
    setError();
    let authCode = localStorage.getItem('auth');
    if (authCode) {
      setRemember(true);
      setCredentials({ isSignIn: false, key: authCode });
    } else {
      setRemember(false);
      setCredentials({ isSignIn: false, key: null });
    }
  }

  const onSignIn = () => {
    if (!credentials.key)
      return;
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_BASE_URL}api/ExcelUploadFunction?code=${credentials.key}`, { mode: "cors" })
      .then(handleErrors)
      .then(jsonData => {
        setLoading(false);
        if (!jsonData)
          setError("Wrong authorization code!");
        else {
          if (remember)
            localStorage.setItem("auth", credentials.key);
          else
            localStorage.removeItem("auth");
          const singInOk = jsonData.history && Array.isArray(jsonData.history);
          setCredentials({
            isSignIn: singInOk, key: credentials.key, initData: {
              excelHistory: jsonData.history,
              crone: jsonData.schedulerInfo,
              lastScanDate: jsonData.lastScanDateTime,
              swaggerUiUrl: jsonData.swaggerUiUrl
            }
          });
        }
      }).catch(error => {
        setLoading(false);
        setError("Wrong authorization code!");
        console.log(error);
        setCredentials({ isSignIn: false, key: '' })
        //toast.error('Authorization request failed. Check console for error details: ' + error, { position: 'top-right', duration: 5000 });
      });
  }

  const handleErrors = (response) => {
    if (!response.ok) {
      throw Error(`Http request ${response.statusText}(${response.status})`);
    }
    return response.json();
  }

  return (
    <>
      <Toaster />
      <Header logo={<TravelportLogo />} rightNavigation={
        <>
          {credentials.isSignIn && <Floating render={function noRefCheck() { <p>ddd</p> }}>
            {/* <Avatar name="Admin user" /><ArrowDownIcon /> */}
            <Button data-icon-align="right" onClick={onSignOff}>
              Sign off
            </Button>
          </Floating>}
        </>} />
      <div>
        {credentials.isSignIn ?
          <Settings settings={credentials} /> :
          (<div className='login-center-card'>
            <Form formHeader="" onSubmit={e => {
              e.preventDefault();
              return onSignIn();
            }}>
              <div className="sb-form-banners" />
              <FormControl error={error}
                id="form-password"
                label="Authorization security code"
                isRequired
                style={{ width: 350 }}
              >
                <Input
                  id="myInput-password"
                  name="password"
                  required
                  value={credentials.key ? credentials.key : ''}
                  autocomplete="off"
                  onChange={(a) => {
                    setCredentials({ isSignIn: credentials.isSignIn, key: a.target.value });
                  }}
                  type="password"
                />
              </FormControl>
              <div style={{ display: 'flex', marginTop: 10 }}>
                <Checkbox label="Remember security code"
                  checked={remember}
                  onChange={() => setRemember(!remember)}
                  style={{ marginRight: 'auto', marginTop: 'auto', marginBottom: 'auto' }} />
                <Button
                  disabled={credentials.key === null || credentials.key.trim().length === 0}
                  data-appearance="primary"
                  data-icon-align="left"
                  data-size="medium"
                  icon={<LogoutIcon />}
                  autoFocus
                  onClick={onSignIn}>Sign in</Button>
              </div>
            </Form>
            {loading && <Spinner overlay percent={50} primaryLabel="Please wait..." />}
          </div>
          )}
      </div>
      {/* <Footer
        copyright="©2023 Travelport. v1.0.0"
        logo={<TravelportLogo />}
      /> */}
    </>
  );
}

export default App;
